import { render, staticRenderFns } from "./pubactivity.vue?vue&type=template&id=7319ecd1&scoped=true&"
import script from "./pubactivity.vue?vue&type=script&lang=js&"
export * from "./pubactivity.vue?vue&type=script&lang=js&"
import style0 from "./pubactivity.vue?vue&type=style&index=0&id=7319ecd1&prod&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7319ecd1",
  null
  
)

export default component.exports